/** A sign-in refused because the person's seat at their company was removed; the account itself still works */
export const seatRemovedErrorCode = 'SEAT_REMOVED';
